import {
    readLocation,
    updateLocation,
    deleteLocation,
} from './locations'

import {
    readRoles,
    readRole,
} from './roles'

import {
    createUser,
    readUsers,
    readUser,
    updateUser,
    createWorkDay,
    updateWorkDay,
    deleteWorkDay,
    readCurrentFlexTimeAccount,
    readRemainingWorkLoadClosingDays,
    submitMonths,
    unsubmitMonths,
} from './users'

import {
    readInstitute,
    readInstitutesLocations,
    createInstituteLocation,
    updateInstitute,
    updateInstituteDefaultLocation,
} from './institutes'

import {
    readAllWorkRecords,
    readWorkRecordsSubmittedStatus
} from './workRecords'

export default {
    readLocation,
    updateLocation,
    deleteLocation,
    readRoles,
    readRole,
    createUser,
    readUsers,
    readUser,
    updateUser,
    updateInstitute,
    createWorkDay,
    updateWorkDay,
    deleteWorkDay,
    readCurrentFlexTimeAccount,
    readRemainingWorkLoadClosingDays,
    submitMonths,
    unsubmitMonths,
    readInstitute,
    readInstitutesLocations,
    createInstituteLocation,
    readAllWorkRecords,
    readWorkRecordsSubmittedStatus,
    updateInstituteDefaultLocation,
}
